<template lang="pug">
.form(v-loading="loading")
  van-field(v-model="formData.title" label="标题" disabled)
  van-field(v-model="formData.prjName" label="项目名称" disabled)
  van-field(v-model="formData.prjCode" label="项目编号" disabled)
  van-field(v-model="formData.operUserName" label="申请人" disabled)
  van-field(v-model="formData.designStageName" label="设计阶段" disabled)
  van-field(v-model="formData.fileLocationName" label="存放目录" disabled)
  van-field(v-model="formData.acceptSpecialtyName" label="校审专业" disabled)
  van-field(v-model="formData.content" label="内容" disabled)
  .list(v-if='isRVT')
    span.title 校审模型:
    .uploderDesc(v-for="item in formData.modelList" @click='preview(item)')
      img(:src="className(item)")
      .fileName {{ item.fileName }}
  .list(v-if='isRVT')
    span.title 校审视图:
    .view(v-for="item in formData.submitDataViewList")
      div 视图名称: {{ item.viewName }}
      div 类型: {{ item.type }}
</template>

<script>
import { mapState } from "vuex";
import flowService from "@/CommonDP/service/flow-service";
import { tableRowIcon, viewH5FileMethods } from "@/CommonDP/utils/docPublic";

export default {
  data () {
    return {
      formData: {
        modelList: []
      },
      loading: false
    };
  },
  computed: {
    ...mapState({
      prjInfo: state => state.projectMg.prjObj,
      floderObj: state => state.uploaderLocal.floderObj,
      enterpriseId: state => state.enterprise.enterpriseId,
      routerParams: state => state.projectMg.routerParams,
      userInfo: state => state.user.userInfo
    }),
    isRVT() {
      return this.routerParams.clientType === 2 && this.routerParams.startFlowMode === 1;
    }
  },
  mounted () {
    this.getBusinessForm();
  },
  methods: {
    async getBusinessForm() {
      try {
        this.loading = true;
        const res = await flowService.getBusinessForm(this.routerParams.flowInstanceId);
        this.formData = res.data.object || {};
        if (this.routerParams.clientType === 2 && this.routerParams.startFlowMode === 1) {
          const modelList = res.data.fileInfoList.filter((ele) => ele.uploadType === 0);
          if (!modelList.length) return;
          modelList[0].fileType = Number(modelList[0].fileType);
          this.formData.modelList = modelList;
        }
        this.loading = false;
      } catch (error) {
        this.$error(error);
      }
    },
    className(row) {
      return tableRowIcon(row);
    },
    // 文件预览打开,文件变色
    async preview(row) {
      this.onLineView(row);
    },
    async onLineView(row) {
      const value = {
        fileId: row.fileId,
        versionId: row.versionIds,
        fileType: row.fileType,
        noNeedIssue: 'true',
        flowInstanceId: this.routerParams.flowInstanceId
      };
      viewH5FileMethods(row, value);
    }
  }
};
</script>

<style lang="scss" scoped>
.list{
  padding: 0 15px;
  display: flex;
  flex-direction: column;
  .uploderDesc{
    display: flex;
    align-items: center;
    width: 100%;
    height: 35px;
    line-height: 35px;
  }
  .view{
    width: 100%;
    line-height: 22px;
    border: 1px solid #ebedf0;
    border-radius: 7px;
    padding: 5px;
    margin-bottom: 5px;
  }
  .title{
    margin: 5px 0;
  }
}
</style>
